/**
 * Angular core imports.
 */
import { Component, Input, EventEmitter, Output } from '@angular/core';
/**
 * Services imports.
 */
import { FunCollectionService } from './../common-functions/fun-collection.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { DataStorageService } from './../../dataservices/data-storage.service';
/**
 * Modal import.
 */
import { ParticipantDetail } from './../../onboarding/interface/global.model';
/**
 * Constant imports.
 */
import { NUMBERS, SPECIAL_CHARACTER } from './../../constants/app.constants';

@Component({
  selector: 'app-tagged-users',
  templateUrl: './tagged-users.component.html',
  styleUrls: ['./tagged-users.component.scss']
})
export class TaggedUsersComponent {
  /**
   * Input decorators used to set data into the component
   * from another component.
   */
  @Input() taggedUsers: ParticipantDetail[] = [];
  /**
   * Limit is used to how many tagged users want to show on card.
   */
  @Input() limit: number;
  /**
   * Emitter used to open the card detail.
   */
  @Output() postDetail: EventEmitter<number> = new EventEmitter();
  /**
   * Special Character from constant file.
   */
  public specialCharacter = SPECIAL_CHARACTER;

  /**
   * Necessary instance.
   */
  constructor(
    public fcs: FunCollectionService,
    public mls: NewLanguageService,
    private dss: DataStorageService) { }

  /**
   * Go to profile page.
   */
  userProfile(profile: ParticipantDetail): void {
    const x = { is_show: false, feed_id: NUMBERS.ZERO, mediaIdx: NUMBERS.ZERO };
    this.dss.showFeedDetailInModal.next(x);
    this.fcs.navigateToUserProfie(profile.custom_id);
  }

  /**
   * used to open post detail page.
   */
  openPostDetail(): void {
    this.postDetail.emit();
  }
}
